export const getData = (service: $TSFixMe) => service?.data?.value || {};
